document.addEventListener('DOMContentLoaded', function () {
  // --- Open/close mobile filter drawer ---
  var openBtn = document.querySelector('.mobile-facets__open-btn');
  var drawer = document.querySelector('.mobile-facets__drawer-content');
  if (openBtn && drawer) {
    openBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = drawer.style.display === 'block';
      drawer.style.display = isOpen ? 'none' : 'block';
      openBtn.textContent = isOpen ? 'FILTER' : 'CLOSE FILTER';
      openBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    document.addEventListener('click', function (e) {
      if (drawer.style.display === 'block' && !drawer.contains(e.target) && !openBtn.contains(e.target)) {
        drawer.style.display = 'none';
        openBtn.textContent = 'FILTER';
        openBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // --- HOLD STATE (no auto submit) ---
  // Remove any auto-submit on input (for AJAX themes, may need to disable a theme handler)
  var filterForms = document.querySelectorAll('form[id^="FacetFiltersForm"]');
  filterForms.forEach(function(form) {
    form.addEventListener('input', function(e) {
      // Do nothing - block auto-submit
      e.stopImmediatePropagation();
    }, true);
  });

  // --- APPLY button submits the filter form ---
  document.querySelectorAll('.apply-filters-text').forEach(function(applyBtn) {
    applyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = applyBtn.closest('form');
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  });

  // (Optional: Clear All handler if you want instant clear and form submit)
  document.querySelectorAll('.mobile-facets__clear').forEach(function(clearBtn) {
    clearBtn.addEventListener('click', function(e) {
      // Let the link work as normal, but you could also:
      // e.preventDefault();
      // var form = clearBtn.closest('form');
      // if (form) form.reset();
      // Optionally submit the form here if you want instant clear
    });
  });
});
